export enum LUMX_CHAT {
    /**
     * @value Incoming message
     * @description Invisible heading associated to a loading message in the chatbox
     */
    INCOMING_MESSAGE = 'LUMX_CHAT.INCOMING_MESSAGE',
    /**
     * @value Message received:
     * @description Invisible heading associated to message received in the chatbox
     */
    MESSAGE_RECEIVED = 'LUMX_CHAT.MESSAGE_RECEIVED',
    /**
     * @value Message sent:
     * @description Invisible heading associated to message sent in the chatbox
     */
    MESSAGE_SENT = 'LUMX_CHAT.MESSAGE_SENT',
    /**
     * @value Scroll to bottom
     * @description Accessible label of the icon button that scrolls the chat thread back to the latest message
     */
    SCROLL_TO_BOTTOM = 'LUMX_CHAT.SCROLL_TO_BOTTOM',
    /**
     * @value Send a message:
     * @description Visually hidden label of the ChatInput text field
     */
    SEND_A_MESSAGE = 'LUMX_CHAT.SEND_A_MESSAGE',
}
